import { Api } from '../api/api';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';

@Injectable()
export class BlockProvider {
  private url: string = 'blocks';

  constructor(public api: Api) {
  }

  post(toUserId: number): Observable<any> {
    return this.api.post(this.url, { to_user_id: toUserId })
  }

}



// WEBPACK FOOTER //
// ./src/providers/block/block.ts